import script from "./DecorationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DecorationPage.vue?vue&type=script&setup=true&lang=js"

import "./DecorationPage.vue?vue&type=style&index=0&id=59e87c58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e87c58"]])

export default __exports__